<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "No Show Tokens",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "No Show Tokens",
            items: [
               {
                  text: "No Show Tokens",
                  href: "/No Show Tokens",
               },                
               
               {
                  text: "Details",
                  active: true,
               },                     
            ],

            payment: {
               amount: 2250,
               payment_id: '',
               notes: '',
            },
            token: '',
            errors: {},

         };
      },
      mounted() {
    
      },

      methods: {
         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },     
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">

                        <router-link :to="{ name: 'doctors.tokens' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                        
                     </div>
                  </div>
                  <!----- top button area ends---->                  

                  <!---- Details starts -------->
                  <div class="row">
                    <div class="col-md-4">
                        <div class="card mini-stats-wid">
                           <div class="card-body">
                              
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2 font-size-18">Guest User                                    
                                    <span class="badge bg-primary rounded-pill">33</span>
                                </p> 
                                 </div>
                            
                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">{{  }}</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <b-button variant="primary" v-b-modal.cancel-modal class="btn-sm mt-2 mr-1">Recall</b-button> 
                                 </span>
                                 </div>
                              </div>
                           </div>
                        </div>
                    </div>
                    
                     
                  </div>
                  <div class="row">

                  <div class="col-md-4">
                        <div class="card mini-stats-wid">
                           <div class="card-body">
                              
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2 font-size-18">Vijesh <span class="badge bg-primary rounded-pill">40</span>
                                </p> 
                                 </div>
                            
                              <div class="media mb-2">
                                 <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">Age: 26 | Male</p>
                                 </div>

                                 <div class="align-self-center ">
                                 <span class="float-end me-3">
                                    <b-button variant="primary" v-b-modal.cancel-modal class="btn-sm mt-2 mr-1">Recall</b-button> 
                                 </span>
                                 </div>
                              </div>
                           </div>
                        </div>
                    </div>
                    </div>
                  <!---- Details ends -------->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
